// @flow
import { Button, SidebarSection, Text, TextBlock } from 'bench-internal-theme';
import { colors } from 'bench-style-constants';
// $FlowFixMe - TS file
import env from 'bench-environment';
import React, { Fragment } from 'react';
import styled from 'styled-components';

import type { DataEntry, AddOn } from './types';
import DataEntries from './DataEntries';
import getFormattedDateString from './getFormattedDateString';

const DetailsLayout = styled.div`
  display: grid;
  grid-template-columns: 130px 1fr;
  grid-row-gap: 8px;
`;

const DataEntriesWrapper = styled.div`
  padding: 16px 0;
`;

const CardHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr min-content min-content;
  grid-column-gap: 8px;
  padding-bottom: 8px;
`;

type JournalEntryInfoCardProps = {
  addOn: AddOn,
  clientCatResponse: ?string,
  clientId: string,
  dataEntries: Array<DataEntry>,
  dateOfTransaction: string,
  dismiss: () => void,
  id: string,
  showJournalEntryEditForm: () => void,
  vendorName: string,
};

const JournalEntryInfoCard = ({
  addOn,
  clientCatResponse,
  clientId,
  dataEntries,
  dateOfTransaction,
  dismiss,
  id,
  showJournalEntryEditForm,
  vendorName,
}: JournalEntryInfoCardProps) => {
  const duiUrl = `${env.location.bkTools}/${clientId}/document-entry/${id}/single`;

  return (
    <SidebarSection>
      <CardHeader>
        <Text styleType="largeBold" uppercase>
          {vendorName}
        </Text>

        <Button
          data-heap-id="je-sidebar-edit-open"
          icon="pencil"
          size="medium"
          styleType="total-ghost"
          onClick={showJournalEntryEditForm}
        />
        <Button icon="close" styleType="total-ghost" onClick={dismiss} />
      </CardHeader>
      <TextBlock styleType="small" color={colors.dust}>
        {getFormattedDateString(dateOfTransaction)}
      </TextBlock>
      <TextBlock styleType="small" color={colors.dust}>
        <a
          data-heap-id="je-sidebar-edit-deui"
          href={duiUrl}
          target="_blank"
          rel="noreferrer noopener"
        >
          Edit in Document Entry
        </a>
      </TextBlock>
      <DataEntriesWrapper>
        <DataEntries dataEntryList={dataEntries} />
      </DataEntriesWrapper>
      <DetailsLayout>
        {clientCatResponse && (
          <Fragment>
            <Text styleType="small" color={colors.cloud}>
              Client Categorization Note:{' '}
            </Text>
            <Text color={colors.ash} styleType="small">
              {clientCatResponse}
            </Text>
          </Fragment>
        )}
        {addOn && (
          <Fragment>
            <Text styleType="small" color={colors.cloud}>
              Linked Add On:{' '}
            </Text>
            <Text color={colors.ash} styleType="small">
              {addOn.name}
            </Text>
          </Fragment>
        )}
      </DetailsLayout>
    </SidebarSection>
  );
};

export default JournalEntryInfoCard;
